import { merge } from '../../helper';
import isEmptyObject from '../../general/isEmpty/isEmptyObject';

import exExternal from '../../external';

import * as exButton from '../button';
import * as exLink from '../../utils/link';
import * as exElement from '../../utils/element';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> | undefined {
    // If there is no container.parent, is required
    if (config.bootstrap === true && !config.container?.parent) {
        console.error('Missing "container.parent", is required!');
        return;
    }

    // Default Config
    const defConfig: Record<string, any> = {
        placement: 'offcanvas-start',
        bootstrap: {
            enabled: true,
        },
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    const elements: Record<string, any> = {};

    // Create element (offcanvas)
    const elOffcanvas = exElement.create({
        merge: defConfig,
        class: {
            new: 'offcanvas ' + defConfig.placement,
        },
    });
    elements.element = elOffcanvas;

    // ------------------------------------------------------------------------

    // Create element (offcanvas header)
    const elOffcanvasHeader = exElement.create({
        merge: defConfig.header,
        class: {
            new: 'offcanvas-header',
        },
    });
    elements.header = elOffcanvasHeader;
    elements.element.appendChild(elOffcanvasHeader);

    // Create element (offcanvas title)
    const elOffcanvasTitle = exElement.create({
        merge: defConfig.title,
        tag: 'h5',
        class: {
            new: 'offcanvas-title',
        },
        html: typeof defConfig.title === 'string' ? defConfig.title : '',
    });
    elements.title = elOffcanvasTitle;
    elOffcanvasHeader.appendChild(elOffcanvasTitle);

    // Create element (offcanvas button)
    const elOffcanvasButton = exButton.create({
        merge: defConfig.button,
        class: {
            new: 'offcanvas-button btn-close text-reset',
        },
        dataset: {
            bsDismiss: 'offcanvas',
        },
    });
    elements.button = elOffcanvasButton;
    elOffcanvasHeader.appendChild(elOffcanvasButton.element);

    // ------------------------------------------------------------------------

    // Create element (offcanvas body)
    const elOffcanvasBody = exElement.create({
        merge: defConfig.body,
        class: {
            new: 'offcanvas-body',
        },
    });
    elements.body = elOffcanvasBody;
    elements.element.appendChild(elOffcanvasBody);

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // If using bootstrap
    if (defConfig.bootstrap?.enabled === true) {
        // Bootstrap (offcanvas)
        const bsOffcanvas = new exExternal.bootstrap.Offcanvas(elements.element, defConfig.bootstrap);
        elements.bs = bsOffcanvas;
    }

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If using link
    if (!isEmptyObject(config.link)) {
        // Create element (link)
        const link = exLink.create({
            merge: config.link,
            dataset: {
                bsToggle: 'offcanvas',
            },
        });
        elements.link = link;

        // If there is id
        if (elements.element.id) {
            link.element.dataset.bsTarget = elements.element.id;
        }
    }

    // If using button
    if (!isEmptyObject(config.button)) {
        // Create element (button)
        const button = exButton.create({
            merge: config.button,
            dataset: {
                bsToggle: 'offcanvas',
            },
        });
        elements.button = button;

        // If there is id
        if (elements.element.id) {
            button.element.dataset.bsTarget = elements.element.id;
        }
    }
}

// ----------------------------------------------------------------------------

export { create };
